// extracted by mini-css-extract-plugin
export default {"wrapper":"sE-z","viewport":"tE-z","container":"uE-z","slide":"vE-z"};